import React from 'react';

export default function TeamsIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g
        id="my-teams"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="ic/supervised_user_circle">
          <g>
            <mask id="mask-2-team" fill="white">
              <path
                d="M11.99,2 C6.47,2 1.99,6.48 1.99,12 C1.99,17.52 6.47,22 11.99,22 C17.51,22 21.99,17.52 21.99,12 C21.99,6.48 17.51,2 11.99,2 Z M15.6,8.34 C16.67,8.34 17.53,9.2 17.53,10.27 C17.53,11.34 16.67,12.2 15.6,12.2 C14.53,12.2 13.67,11.34 13.67,10.27 C13.66,9.2 14.53,8.34 15.6,8.34 L15.6,8.34 Z M9.6,6.76 C10.9,6.76 11.96,7.82 11.96,9.12 C11.96,10.42 10.9,11.48 9.6,11.48 C8.3,11.48 7.24,10.42 7.24,9.12 C7.24,7.81 8.29,6.76 9.6,6.76 Z M9.6,15.89 L9.6,19.64 C7.2,18.89 5.3,17.04 4.46,14.68 C5.51,13.56 8.13,12.99 9.6,12.99 C10.13,12.99 10.8,13.07 11.5,13.21 C9.86,14.08 9.6,15.23 9.6,15.89 Z M11.99,20 C11.72,20 11.46,19.99 11.2,19.96 L11.2,15.89 C11.2,14.47 14.14,13.76 15.6,13.76 C16.67,13.76 18.52,14.15 19.44,14.91 C18.27,17.88 15.38,20 11.99,20 L11.99,20 Z"
                id="path-1"></path>
            </mask>
            <g id="Shape" fillRule="nonzero"></g>
            <g
              id="Neutral-alpha-/-N500A"
              mask="url(#mask-2-team)"
              fill="#0065FF">
              <polygon id="N500A" points="0 24 24 24 24 0 0 0"></polygon>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
